export default function Footer() {
  const footerLinks = [
    {
      title: '热门漫画',
      links: ['热血战斗', '恋爱甜宠', '悬疑推理', '仙侠修真', '搞笑日常', '都市言情'],
    },
    {
      title: '平台服务',
      links: ['下拉式阅读', '无限滚动', '离线下载', '夜间模式', '智能推荐', '免费全集'],
    },
    {
      title: '关于我们',
      links: ['平台介绍', '联系我们', '投稿合作', '意见反馈', '用户协议', '隐私政策'],
    },
  ];

  return (
    <footer id="footer" className="bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <span className="text-2xl font-heading font-bold block mb-3" style={{ color: 'oklch(var(--primary-500))' }}>
              甜柚漫画
            </span>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              领先的竖屏下拉式漫画阅读平台。无限滚动技术，免费全集漫画，手机畅读体验，热门漫画一网打尽。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      onClick={(e) => e.preventDefault()}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/70 pt-6 mb-6">
          <h4 className="text-sm font-semibold text-foreground-800 mb-3">合作伙伴</h4>
          <p className="text-xs text-foreground-500">更多合作伙伴即将入驻，敬请期待。</p>
        </div>

        <div className="border-t border-background-200/70 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 甜柚漫画 tianyoumanga.com — 免费全集漫画 竖屏下拉式阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#" onClick={(e) => e.preventDefault()} className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}